var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_29154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 26.5C29.7581 26.5005 30.1667 26.6713 30.4756 26.9775C30.7845 27.2837 30.9704 27.7022 30.9953 28.1474C31.0202 28.5927 30.8822 29.0312 30.6096 29.3732C30.3369 29.7153 29.9502 29.9351 29.5283 29.9878L29.3333 30H2.66667C2.24187 29.9995 1.83328 29.8287 1.52439 29.5225C1.21549 29.2163 1.02961 28.7978 1.00471 28.3526C0.979818 27.9073 1.11779 27.4688 1.39044 27.1268C1.66309 26.7847 2.04984 26.5649 2.47167 26.5122L2.66667 26.5H29.3333ZM29.3333 14.25C29.7754 14.25 30.1993 14.4344 30.5118 14.7626C30.8244 15.0908 31 15.5359 31 16C31 16.4641 30.8244 16.9092 30.5118 17.2374C30.1993 17.5656 29.7754 17.75 29.3333 17.75H2.66667C2.22464 17.75 1.80072 17.5656 1.48816 17.2374C1.17559 16.9092 1 16.4641 1 16C1 15.5359 1.17559 15.0908 1.48816 14.7626C1.80072 14.4344 2.22464 14.25 2.66667 14.25H29.3333ZM29.3333 2C29.7754 2 30.1993 2.18437 30.5118 2.51256C30.8244 2.84075 31 3.28587 31 3.75C31 4.21413 30.8244 4.65925 30.5118 4.98744C30.1993 5.31563 29.7754 5.5 29.3333 5.5H2.66667C2.22464 5.5 1.80072 5.31563 1.48816 4.98744C1.17559 4.65925 1 4.21413 1 3.75C1 3.28587 1.17559 2.84075 1.48816 2.51256C1.80072 2.18437 2.22464 2 2.66667 2H29.3333Z",
    fill: "#E94B52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_29154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerRed);
export default __webpack_public_path__ + "static/media/burger_red.9dc9f39d6a655673db27cc319b3a0216.svg";
export { ForwardRef as ReactComponent };